module.exports = __webpack_public_path__ + "static/eternal_flame_priest-053d861ddd691cdf016ea6afcb589c77.jpeg";